import styled from "styled-components";

export const TitleCellContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  /* Hide edit icon by default, show on hover */
  /* Target the SVG that is a direct child of the Flex (which is the first div child) */
  > div {
    display: flex;
    align-items: center;

    > svg:last-child {
      visibility: hidden;
      margin-left: 0.4em;
      position: relative;
      top: -1px;
    }
  }

  :hover {
    > div > svg:last-child {
      visibility: visible;
    }
  }
`;

export const MembersContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  line-height: 1.5;
`;
